import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import classnames from "classnames";
import { memo } from "react";
import styles from "./LexicalContentEditable.module.css";

interface LexicalContentEditableProps {
  contentEditable?: boolean;
  thumbnail?: boolean;
}
export const LexicalContentEditable = memo(
  ({ contentEditable, thumbnail = false }: LexicalContentEditableProps) => {
    return (
      <ContentEditable
        className={classnames(styles.contentEditable, {
          [styles.contentEditableThumbnail]: thumbnail,
        })}
        contentEditable={contentEditable}
      />
    );
  },
);
LexicalContentEditable.displayName = "LexicalContentEditable";
